import { ListItem, ListItemContent } from '@mr-yum/frontend-ui'
import MemberIcon from 'components/Icons/Member'
import React from 'react'
import { useIntl } from 'react-intl'

interface Props {
  onClick?: () => void
}

export const CartMemberLoginCTA = ({ onClick }: Props) => {
  const intl = useIntl()

  return (
    <ListItem size="lg" asChild isInteractive>
      <button onClick={onClick}>
        <ListItemContent
          label={intl.formatMessage({
            defaultMessage: 'Login',
            id: 'AyGauy',
          })}
          labelWeight="normal"
          size="lg"
          leftIcon={<MemberIcon />}
        />
      </button>
    </ListItem>
  )
}
